(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gracie-landing"] && !Shopify.designMode) return;
  try {
    
    (() => {
      document.querySelectorAll('[data-gracie-landing]').forEach((section) => {
        if (section.dataset.initialized === 'true') return;
        section.dataset.initialized = 'true';

        const heroImage = section.querySelector('.glp__hero-image');
        section.querySelectorAll('.glp__thumb').forEach((thumb) => {
          thumb.addEventListener('click', () => {
            if (heroImage) {
              heroImage.src = thumb.dataset.fullImage;
              heroImage.alt = thumb.dataset.alt || '';
            }
            section.querySelectorAll('.glp__thumb').forEach((item) => item.classList.remove('is-active'));
            thumb.classList.add('is-active');
          });
        });

        const form = section.querySelector('.glp__form');
        const select = section.querySelector('[data-variant-select]');
        const price = section.querySelector('[data-price]');
        const buyNow = section.querySelector('[data-buy-now]');
        const error = section.querySelector('[data-form-error]');

        if (select && price) {
          select.addEventListener('change', () => {
            const option = select.options[select.selectedIndex];
            price.textContent = option.dataset.price || price.textContent;
            if (buyNow) buyNow.disabled = option.disabled;
          });
        }

        if (buyNow && form) {
          buyNow.addEventListener('click', async () => {
            buyNow.disabled = true;
            buyNow.textContent = 'Opening secure checkout…';
            if (error) error.hidden = true;
            try {
              const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: { 'Accept': 'application/json' },
                body: new FormData(form)
              });
              if (!response.ok) throw new Error('Unable to add item');
              window.location.href = window.Shopify.routes.root + 'checkout';
            } catch (eventError) {
              if (error) error.hidden = false;
              buyNow.disabled = false;
              buyNow.textContent = 'Buy Now';
            }
          });
        }
      });
    })();

  } catch(e) { console.error(e); }
})();
})();
